import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Alert, Row, Col, Card, OverlayTrigger, Tooltip, Container } from 'react-bootstrap';
import { fetchDailyOrdersByMonth, fetchDailyOrdersOnlyMonths } from '../redux/slice/dailyOrdersSlice';
import { formatDate } from '../utils/formatDate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import MonthHelpers from '../components/MonthHelpers';
import '../assets/DailyOrdersReports.css'
import LoadingComponent from '../components/LoadingComponent';
import Notifications from '../components/Notifications';
import { getMonthName } from '../utils/getMonthName';
import { fetchOrdersByDate } from '../redux/slice/orderSlice';
import { exportToCSV } from '../utils/exportToCSV';
const DailyOrdersReports = () => {
  const dispatch = useDispatch();
  const { isTodayOrder, todaysOrder, dailyOrders, status, error, getMonthError, getMonthStatus } = useSelector(state => state.dailyOrders);
  const { status: orderStatus } = useSelector(state => state.orders);
  const [date, setDate] = useState({
    day: '',
    month: '',
    year: ''
  })
  const [toast, setToast] = useState({
    message: '',
    variant: 'success',
    show: false
  });
  const [hoveredDate, setHoveredDate] = useState(null);


  useEffect(() => {
    const now = new Date();
    const day = now.getDate();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();

    // Ενημέρωση κατάστασης με τρέχουσες τιμές ημερομηνίας
    setDate({
      day,
      month,
      year
    });

    dispatch(fetchDailyOrdersByMonth({ month, year }))
  }, [dispatch]);

  const handleDailyOrdersByMonth = (month, year) => {
    dispatch(fetchDailyOrdersOnlyMonths({ month, year }))
  }

  const handleDownload = (order, dt) => {

    const [year, month, day] = dt.split('-');

    dispatch(fetchOrdersByDate({ day, month, year })).then(response => {
      if (response.meta.requestStatus === 'fulfilled') {
        if (response.payload.length > 0) {
          exportToCSV(response.payload, order);
          setToast({
            message: `Η λήψη της αναφοράς για ${dt ? 'την' : 'τον μήνα '} ${dt ? formatDate(dt) : getMonthName(month)} πραγματοποιήθηκε με επιτυχία!`,
            variant: 'success',
            show: true
          });
        } else {
          setToast({
            message: `Δεν υπάρχουν δεδομένα αναφοράς για ${dt ? 'την' : 'τον μήνα '} ${dt ? formatDate(dt) : getMonthName(month)}.`,
            variant: 'warning',
            show: true
          });
        }
      } else {

        let errorMessage = 'Υπήρξε πρόβλημα κατά την λήψη του αρχείου';

        if (response.error) {

          if (response.error.message) {
            errorMessage = response.error.message;
          } else if (response.payload) {
            errorMessage = response.payload;
          }
        }

        setToast({
          message: errorMessage,
          variant: 'danger',
          show: true
        });
      }
    }).catch((error) => {
      setToast({
        message: `Σφάλμα κατά τη διαδικασία: ${error.message}`,
        variant: 'danger',
        show: true
      });
    });
  };

  return (
    <>
      {status === 'loading' && <LoadingComponent />}
      {orderStatus === 'loading' && <LoadingComponent />}
      {status === 'failed' && <Alert variant="danger">{error}</Alert>}
      {status === 'succeeded' && (
        <Container className='user-management-container' style={{ minHeight: '100vh' }}>
          {isTodayOrder && <Row >
            <Col md={12}>
              <Card className="content-card">
                <Card.Header className="d-flex justify-content-between align-items-center">
                  <div>

                    <h3>
                      Σημερινές παραγγελίες
                    </h3>
                    <h6 style={{ fontWeight: '300', fontSize: '16px', color: 'gray' }}>
                      {formatDate(todaysOrder[0]?.date)}
                    </h6>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Row className="g-4">
                    {['total', 'takeaway_lafa', 'takeaway_spa', 'consume_lafa'].map((type, index) => {
                      const titles = ['Σύνολο Παραγγελιών', 'Παραλαβή ΛΑΦΑ', 'Παραλαβή ΣΠΑ', 'Κατανάλωση ΛΑΦΑ'];

                      return (
                        <Col md={3} key={index}>
                          <Card className="content-card-inner shadow-sm">
                            <Card.Body>
                              <Card.Title className="card-title d-flex align-items-center">
                                {titles[index]}
                              </Card.Title>
                              <Card.Text className="card-content">
                                {Object.entries(todaysOrder[0].orders_summary).map(([meal, summary]) => (
                                  <span className="summary-item" key={meal}>
                                    <strong className='p'>{meal === 'Bread' ? 'Αρτος Λευκός' : meal === 'grained_bread' ? 'Αρτος Ολικής' : meal}:</strong> {summary[type]}<br />
                                  </span>
                                ))}
                              </Card.Text>
                            </Card.Body>
                          </Card>
                        </Col>
                      );
                    })}
                  </Row>
                </Card.Body>

              </Card>
            </Col>


          </Row>}
          <Row>
            <Col md={12}>
              <Card className="content-card">
                <Card.Header className="d-flex justify-content-between align-items-center">


                  <Card.Title >
                    <h4 className="hide-on-mobiles">Παραγγελίες όλου μήνα</h4>
                    <h6 style={{ color: 'gray' }}>{getMonthName(date?.month)}</h6>
                  </Card.Title>
                </Card.Header>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                  <MonthHelpers month={date?.month} year={date?.year} setDate={setDate} handleDailyOrdersByMonth={handleDailyOrdersByMonth} />
                </div>

                <div className='table-container'>
                  {getMonthStatus === 'loading' && <LoadingComponent />}
                  {getMonthStatus === 'failed' && <Alert variant="danger">{getMonthError}</Alert>}
                  {dailyOrders.length > 0 && (
                    <Table xs={12} className='table-menu' bordered striped responsive>
                      <thead>
                        <tr>
                          <th>Ημερομηνία</th>
                          <th>Πιάτο</th>
                          <th>Σύνολο</th>
                          <th className="hide-on-mobile">Παραλαβή ΛΑΦΑ</th>
                          <th className="hide-on-mobile">Παραλαβή ΣΠΑ</th>
                          <th className="hide-on-mobile">Κατανάλωση ΛΑΦΑ</th>
                          <th>Excel</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dailyOrders.map((order, index) => (
                          Object.entries(order?.orders_summary).map(([meal, summary], idx) => (

                            <tr
                              className={hoveredDate === order?.date ? 'table-secondary' : ''}
                              key={`${order?.id}-${meal}`}
                              onMouseEnter={() => setHoveredDate(order?.date)}
                              onMouseLeave={() => setHoveredDate(null)}
                            >
                              {idx === 0 && (
                                <td rowSpan={Object.entries(order?.orders_summary).length}>
                                  <br></br>
                                  <br></br>
                                  <br></br>
                                  {formatDate(order?.date)}
                                </td>
                              )}
                              <td >{meal === 'grained_bread' ? 'Αρτος Ολικής' : meal === 'Bread' ? 'Αρτος Λευκός' : meal}</td>
                              <td>{summary?.total}</td>
                              <td className="hide-on-mobile">{summary?.takeaway_lafa}</td>
                              <td className="hide-on-mobile">{summary?.takeaway_spa}</td>
                              <td className="hide-on-mobile">{summary?.consume_lafa}</td>
                              {idx === 0 && (
                                <td rowSpan={Object.entries(order?.orders_summary).length} style={{ textAlign: 'center' }}>
                                  <br></br>
                                  <br></br>
                                  <br></br>
                                  <OverlayTrigger overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                                    Αναφορά για την {formatDate(order?.date)} (Αρχείο .csv)
                                  </Tooltip>
                                  }>
                                    <FontAwesomeIcon className="fa-icons" icon={faDownload} color='#FFF3DA' size='lg' style={{ cursor: 'pointer' }} onClick={() => { handleDownload(order, order?.date) }} />
                                  </OverlayTrigger>
                                </td>
                              )}
                            </tr>
                          ))
                        ))}
                      </tbody>
                    </Table>
                  )}

                </div>

              </Card>
            </Col>
          </Row>

          <Notifications
            message={toast?.message}
            variant={toast?.variant}
            show={toast?.show}
            onClose={() => setToast({ ...toast, show: false })}
          />
        </Container>
      )}
    </>
  );
};

export default DailyOrdersReports;